import http from "../../core/services/http.service";
import ExportsService from "../../core/services/exports.service";
import {AppSettings} from "@/shared/AppSettings";

const LotsService = {
  sendUnsoldInfo(data) {
    return http.put('/api/v1/inventories/reservations/batch-mark-unsold-extended/', data);
  },
  getLots(params = null) {
    return http.get('/api/v1/lots/', {params});
  },
  getLot(id, expand, params = {}) {
    return http.get(`/api/v1/lots/${id}/?expand=${expand}`, {params});
  },
  updateLot(id, data, expand = '') {
    return http.put(`/api/v1/lots/${id}/?expand=${expand}`, data);
  },
  removeLot(uuid) {
    return http.delete(`/api/v1/lots/${uuid}`)
  },
  batchRemoveReservations(uuid) {
    return http.delete(`/api/v1/inventories/reservations/`, {
      data: {uuid}
    });
  },
  batchMarkLotsUnsold(uuids) {
    return http.put(`/api/v1/inventories/reservations/batch-mark-unsold/`, {
      uuids
    });
  },
  getLatestReservationProposals(payload) {
    return http.post(`/api/v1/inventories/reservations/latest-reservation-proposals/`, payload);
  },
  getLotUpInfo(lot, auctionUuid, params = {}, expand = '') {
    return http.get(`/api/v1/lots/lot-up-info/${lot}/?auction_uuid=${auctionUuid}&expand=${expand}`, {params});
  },
  createLotImagesFromZip(data, onUploadProgress) {
    return http.post('/api/v1/lots/images/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  createLotImagesFromBulk(data, onUploadProgress) {
    return http.post('/api/v1/lots/images/bulk/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  uploadLotUpFile(data, onUploadProgress) {
    return http.post('/api/v1/inventories/batch-lot-up/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  reserveLots(data) {
    return http.post('/api/v1/lots/', data);
  },
  getReservations(params = null, expand = '') {
    return http.get(`/api/v1/inventories/reservations/?expand=${expand}`, {params});
  },
  getReservation(id, expand, params = {}) {
    return http.get(`/api/v1/inventories/reservations/${id}/?expand=${expand}`, {params});
  },
  getReservationByLotNo(expand, params = {}) {
    return http.get(`/api/v1/inventories/reservations/?expand=${expand}`, {params});
  },
  createReservation(data, expand = '') {
    return http.post(`/api/v1/inventories/reservations/?expand=${expand}`, data);
  },
  updateReservation(id, data, expand) {
    return http.put(`/api/v1/inventories/reservations/${id}/?expand=${expand}`, data);
  },
  withdrawReservation(reservationUuid) {
    return http.post(`/api/v1/inventories/reservations/${reservationUuid}/withdraw/`, {}, {}, true);
  },
  batchWithdrawReservation(uuids) {
    return http.post(`/api/v1/inventories/reservations/batch-withdraw/`, {uuids});
  },
  removeReservation(uuid) {
    return http.delete(`/api/v1/inventories/reservations/${uuid}/`)
  },
  async getLotsImagesZipData({auctionUuid, template}) {
    return http.post(`/api/v1/lots/${auctionUuid}/batch-download-lot-images/`, template);
  },
  getLotPreviousAndNext(uuid) {
    return http.get(`/api/v1/lots/info/?lot_uuid=${uuid}`);
  },
  updateLotTerms(payload) {
    return http.post(`/api/v1/lots/update-terms/${payload.lotUuid}/`, payload.data)
  },
  updateSaleStatus(status, data) {
    return http.post(`/api/v1/auctions/${status}/`, data);
  },
  getLotByLotNo(no, expand, params = {}) {
    return http.get(`/api/v1/lots/sold-lot-info/${no}/?expand=${expand}`, {params});
  },
  syncLotsWithTimedAuction() {
    return http.post(`/api/v1/auctions/sync-with-timed-provider/`);
  },
  createNegotiationBid(data) {
    return http.post('/api/v1/bids/create-winning-bid/', data);
  },
  getLivePerformanceData(params = null) {
    return http.get('/api/v1/lots/live-performance/', {params});
  },
  partialUpdateLot(id, data) {
    return http.patch(`/api/v1/inventories/reservations/${id}/`, data);
  },
  async getLotPrintOuts(uuids) {
    let response = await ExportsService.generateToken();
    if (!response.success) {
      return false;
    }
    return AppSettings.url() + `/api/v1/lots/printouts/?token=${response.body.token}&uuids=${uuids}`
  },
  async getLotPrintOutsNew(params) {
    return http.get('/api/v1/lots/printouts/', {params});
  },
  reassignReservations(data) {
    return http.post(`/api/v1/inventories/reservations/reassign/`, data)
  },
  updateFinancialItemCharge(uuid, data, expand = '') {
    return http.patch(`/api/v1/finances/financial-item-charges/${uuid}/?expand=${expand}`, data)
  },
  bulkAdjustPrice(id, data) {
    return http.post(`/api/v1/inventories/reservations/bulk-adjust-price/`, data);
  },
  getNextLotNumbers(data) {
    return http.post(`/api/v1/lots/next-lot-numbers/`, data);
  },
  batchUpdateLotSession(data) {
    return http.post(`/api/v1/inventories/reservations/batch-update-auction-dates/`, data);
  },
  batchFinancialUpdate(data) {
    return http.post(`/api/v1/lots/batch-financial-update/`, data);
  },
  batchUpdateLotCollection(data) {
    return http.post(`/api/v1/inventories/reservations/batch-update-auction-collection/`, data);
  },
  batchUpdateHideLot(data) {
    return http.post(`/api/v1/inventories/reservations/batch-update-hide-lot/`, data);
  },
  setSourceOfSale(params) {
    return http.patch(`/api/v1/lots/sale-result/${params.lot_uuid}/`, params);
  },
  batchUpdateAuctionLotImages(data){
    return http.post(`/api/v1/inventories/reservations/batch-update-lot-image-for-auction/`, data)
  },
  checkDpvEligible(params) {
    return http.get('/api/v1/lots/check-dpv-eligible/', {params});
  }
};

export default LotsService;
